const onboardingES = {
	/* ---------- COMMON ---------- */
	showSteps: "Mostrar pasos",
	hideSteps: "Ocultar pasos",
	stepsCompleted: "pasos completados",

	/* ---------- BANNER ---------- */
	bannerTitle: "Completa la configuración de tu tienda",
	bannerSubtitle: "finaliza para comenzar a recibir reservas",

	/* ---------- BUBBLE / HINT ---------- */
	hintTitle: "Completa tu configuración",
	hintText: "Finaliza estos pasos para activar tu tienda y comenzar a recibir reservas.",

	/* ---------- OWNER / ADMIN ---------- */
	launchShop: "Lanzar tienda",
	launching: "Redirigiendo...",
	errors: {
		billing: "No se pudo iniciar la facturación",
	},
	steps: {
		shopInfo: "Información de la tienda",
		schedule: "Horario del propietario",
		services: "Agregar servicios",
		images: "Subir imágenes",
		openingHours: "Horario de apertura",
		contactInfo: "Información de contacto",
		attributes: "Atributos",
	},

	/* ---------- STAFF ---------- */
	staff: {
		bannerTitle: "Completa tu perfil de empleado",
		bannerSubtitle: "finaliza para comenzar a recibir reservas",
		launch: "Activar perfil del personal",
		launching: "Activando...",
		steps: {
			schedule: "Horario del empleado",
			services: "Vincular servicios",
		},
		messages: {
			success: "¡Perfil del personal activado!",
			error: "No se pudo activar el perfil del personal.",
		},
	},
};

export default onboardingES;